import { render, staticRenderFns } from "./UserChangeProfileForm.vue?vue&type=template&id=2911e9a9"
import script from "./UserChangeProfileForm.vue?vue&type=script&lang=js"
export * from "./UserChangeProfileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports